'use strict';

var defineProperty = require('../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var SvgWrapper = require('../../../core/SvgWrapper.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var GarageIcon = function GarageIcon(props) {
  return React__default["default"].createElement(SvgWrapper, _objectSpread({}, props), React__default["default"].createElement("g", {
    id: "onboarding-/-industry-/-garage",
    stroke: "none",
    strokeWidth: "1",
    fillRule: "evenodd"
  }, React__default["default"].createElement("path", {
    d: "M29,30 L25.2844899,30 L25.2844899,13.2 L6.71408164,13.2 L6.71408164,30 L3,30 L3,9.46666667 L15.9992858,2 L28.9985715,9.46666667 L28.9985715,30 L29,30 Z M8.57112247,15.0666667 L23.427449,15.0666667 L23.427449,18.8 L8.57112247,18.8 L8.57112247,15.0666667 L8.57112247,15.0666667 Z M8.57112247,20.6666667 L23.427449,20.6666667 L23.427449,24.4014359 L8.57112247,24.4014359 L8.57112247,20.6666667 L8.57112247,20.6666667 Z M23.427449,26.2652308 L23.427449,30 L8.57112247,30 L8.57112247,26.2652308 L23.427449,26.2652308 Z",
    id: "Shape"
  })));
};

module.exports = GarageIcon;
